import { render, staticRenderFns } from "./add-queue.vue?vue&type=template&id=58f7f720&scoped=true"
import script from "./add-queue.vue?vue&type=script&lang=ts"
export * from "./add-queue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f7f720",
  null
  
)

export default component.exports